import React, { useEffect, useState } from "react";
import { appFetchJson } from "../../../utils/http";
import apiRoutes from "../../../api/apiRoutes";

export default function VerEess({ id, onClose = () => {} }) {
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [e, setE] = useState(null);

  useEffect(() => {
    if (!id) return;

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setErr("");

      try {
        const data = await appFetchJson(apiRoutes.eess.detail(id));

        if (!cancelled) {
          setE(data);
        }
      } catch (error) {
        console.error("Error al cargar EE.SS:", error);
        if (!cancelled) {
          setErr("Error al cargar la estación.");
          setE(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [id]);

  const rows = [
    ["Cod. EE.SS.", e?.codigoEstacion],
    ["EE.SS.", e?.nombreEstacion],
    ["EE.SS. Flota", e?.eessFlota],
    ["Cliente", e?.clienteNombre],

    ["Ciudad", e?.ciudadNombre],
    ["Departamento", e?.zonaNombre],
    ["Dirección", e?.descricaoDireccion],

    ["Teléfono 1", e?.descricaoTelefono1],
    ["Teléfono 2", e?.descricaoTelefono2],

    ["Fecha Alta", e?.dataAlta],
    ["RUC", e?.descricaoRuc],
    ["Nro. Verificador", e?.numeroVerificador],

    ["Cant. Estaciones", e?.cantidadEstaciones],
    ["Email", e?.descricaoEmail],
    ["Zona", e?.zonaNombre],

    ["Latitud", e?.latitud],
    ["Longitud", e?.longitud],
  ];

  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg">
        {/* HEADER */}
        <div className="modal-header">
          <h2 className="section-title">Datos de EE.SS.</h2>
        </div>

        {/* BODY */}
        <div className="modal-body">
          {loading && (
            <div className="py-6 text-center text-gray-600">
              Cargando…
            </div>
          )}

          {!loading && err && (
            <div className="py-6 text-center text-red-600">
              {err}
            </div>
          )}

          {!loading && !err && e && (
            <div className="form-grid">
              {rows.map(([label, value]) => (
                <Fila key={label} label={label} value={value} />
              ))}
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="flex justify-end">
            <button className="btn-fil" onClick={onClose}>
              Nueva consulta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value">
        {value !== null && value !== undefined && value !== ""
          ? value
          : <span className="text-gray-400">—</span>}
      </div>
    </div>
  );
}
